<template>

    <Row cmpt="TitleRow" :class="background()">
      <Column :width="left"></Column>
      <Column :class="classes()" :width="middle" style="padding-left:5px;padding-right:5px">
        <slot />
      </Column>
      <Column :width="right"></Column>
    </Row>

</template>

<script>

import { mapGetters } from 'vuex'

import Row from "@/portals/shared/library/box/Row.vue";
import Column from "@/portals/shared/library/box/Column.vue";

export default {
  name: 'portals-shared-library-title-title-row',
  components: {
    Row,
    Column,
  },
  props: {
    align:    { type: String, default: "center" },
    cmpt:     { type: String, default: "title" },
    fontSize: { type: String, default: "medium" },
    subtitle: { type: Boolean, default: false },
    left:     { type: Number, default: 0 },
    right:    { type: Number, default: 0 },
    type:     { type: String, default: "" },
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters([
                   'domain',
                 ]),
    middle: function() {
      return 15 - this.left - this.right;
    },
  },
  methods: {
    classes: function() {
      var value = "";
      if (this.fontSize) {
        value = "rc-text-" + this.fontSize;
      }

      if (this.subtitle) {
        value = "rc-text-small";
      }
      
      if (this.align === "left") {
        value += " rc-text-left";
      } else if (this.align === "right") {
        value += " rc-text-right";
      } else {
        value += " rc-text-centre";
      }
      
      return value;
    },
    background: function() {
      var value = "rc-title-background";
      if (this.subtitle) {
        value = "rc-title-background-light";  
      }
      if (this.type === "warning") {
        value = " rc-title-warning-left";
      }
      if (this.type === "error") {
        value = " rc-title-error-left";
      }
      return value;
    },
  },
}
</script>